<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(operazioneMagazzino)="{ item }">
                            <span v-if="item.operazioneMagazzino === -1" class="text-danger">
                                <font-awesome-icon icon="arrow-down"></font-awesome-icon>
                                Scarico
                            </span>
                            <span v-else-if="item.operazioneMagazzino === 1" class="text-success">
                                <font-awesome-icon icon="arrow-up"></font-awesome-icon>
                                Carico
                            </span>
                            <span v-else-if="item.operazioneMagazzino === 0" class="text-muted">
                                <font-awesome-icon icon="equals"></font-awesome-icon>
                                Invariato
                            </span>
                            <span v-else class="text-secondary"> N/A </span>
                        </template>
                        <template #cell(operazioneContabile)="{ item }">
                            <span v-if="item.operazioneMagazzino === -1" class="text-danger">
                                <font-awesome-icon icon="arrow-down"></font-awesome-icon>
                                Avere
                            </span>
                            <span v-else-if="item.operazioneMagazzino === 1" class="text-success">
                                <font-awesome-icon icon="arrow-up"></font-awesome-icon>
                                Dare
                            </span>
                            <span v-else-if="item.operazioneMagazzino === 0" class="text-muted">
                                <font-awesome-icon icon="equals"></font-awesome-icon>
                                Invariato
                            </span>
                            <span v-else class="text-secondary"> N/A </span>
                        </template>
                        <template #cell(stampaPrezzi)="{ item }">
                            <span v-if="item.stampaPrezzi === true" class="text-success">
                                <font-awesome-icon icon="check"></font-awesome-icon>
                                Sì
                            </span>
                            <span v-else class="text-danger">
                                <font-awesome-icon icon="times"></font-awesome-icon>
                                No
                            </span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Configurazione" variant="outline-secondary" @click="onClickViewDocumentoMagazzino(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Configurazione" variant="outline-success" @click="onClickEditDocumentoMagazzino(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Configurazione" variant="outline-danger" @click="onClickDeleteDocumentoMagazzino(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
                <magazzino-tipo-documento-modal-edit-component ref="cmpMagazzinoDocumentoModalEdit" @saveDocumentoArticolo="loadDataDocumento" @documentoArticoloDelete="loadDataDocumento" />
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoTipoDocumentoModalEditComponent from "./MagazzinoTipoDocumentoModalEditComponent.vue";
export default {
    name: "ConfigurazioneMagazzinoFornitoriListComponent",
    components: { MagazzinoTipoDocumentoModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            id: null,
            currentPage: 1,
            pathResource: "/causalidocumento",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroDocumento: { codiceAzienda: null, um: null },
            fields: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Codice Tipo Documento",
                    key: "codiceTipoDocumento",
                    sortable: false,
                },
                {
                    label: "Operazione Magazzino",
                    key: "operazioneMagazzino",
                    sortable: false,
                },
                {
                    label: "Operazione Contabile",
                    key: "operazioneContabile",
                    sortable: false,
                },
                {
                    label: "Descrizione Causale",
                    key: "descrizioneCausale",
                    sortable: false,
                },
                {
                    label: "Stampa prezzi",
                    key: "stampaPrezzi",
                    sortable: false,
                },
                {
                    label: "Soggetti Collegati",
                    key: "soggettiCollegati",
                    sortable: false,
                },
                {
                    label: "Documenti Collegati",
                    key: "documentiCollegati",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadDataDocumento();
        },
    },
    methods: {
        // ==================== CRUD ====================
        loadDataDocumento() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroDocumento"]) {
                me.filtroDocumento = JSON.parse(sessionStorage["filtroDocumento"]);
                me.$emit("updateFilter", me.filtroDocumento);
            }
            me.filtroDocumento.page = me.currentPage;
            me.filtroDocumento.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroDocumento, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data;
            me.rows = response.data.data.length;
            console.log("Success");
            console.log(me.items);
            console.log(response);

            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        // ==================== UTILITY ====================
        onClickViewDocumentoMagazzino(item) {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoModalEdit.show(item, true);
        },
        onClickEditDocumentoMagazzino(item) {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoModalEdit.show(item, false);
        },
        onNuovoDocumentoArticolo() {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoModalEdit.show(
                {
                    id: null,
                    codiceTipoDocumento: null,
                    operazioneMagazzino: null,
                    operazioneContabile: null,
                    descrizioneCausale: null,
                    stampaPrezzi: false,
                    soggettiCollegati: null,
                    documentiCollegati: null,
                },
                false
            );
        },
        onClickDeleteDocumentoMagazzino(item) {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoModalEdit.onDeleteDocumentoArticolo(item);
        },
    },
};
</script>
